Customer.Users ||= {}

class Customer.Users.ProfileContentHistoryView extends Backbone.View
  template: JST["backbone/templates/customer/users/profile_content_history_chart"]

  className: 'main-profile-section main-profile-content-history-chart'

  initialize: (@options = {}) ->
    @searchQuery = @options.search_query

  render: ->
    @$el.html(@template())
    @_renderContentHistoryChart()
    return this

  _renderContentHistoryChart: ->
    @_renderChart(new Monitoring.Views.Charts.CustomProfileContentHistoryChart({
      searchQuery: @searchQuery
      responsePostProcessor: @responsePostProcessor
      settings:
        title: ''
        maximized: false
    }))

  _renderChart: (chart) ->
    chart.appendChart(@$el.find('.chart-container'))
    chart.$el.find('#close_chart').addClass('hidden')

  responsePostProcessor: (response) ->
    result = { series: [] }
    # example of a response to be converted to the needed format:
    # {
    #   values: [
    #     {
    #         count: 5
    #         time: 1449619200000
    #     },
    #     {
    #         count: 4
    #         time: 1450224000000
    #     },
    #     {
    #         count: 20
    #         time: 1450656000000
    #     }
    #   ]
    # }
    # this example must be converted to the following:
    # {
    #   series: [
    #     {
    #       name: 'UGC'
    #       color: '#3090C7' # Blue Ivy
    #       data: [[1449619200000, 5], [1450224000000, 4], [1450656000000, 20]]
    #     }
    #   ]
    # }
    data = _.map(response.values, (value) ->
      [value.time, value.count]
    )
    result.series.push({name: 'UGC', color: '#3090C7', data: data})
    result